import { render, staticRenderFns } from "./BattleReport.vue?vue&type=template&id=a345606c&"
import script from "./BattleReport.vue?vue&type=script&lang=js&"
export * from "./BattleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports